module.exports = __webpack_public_path__ + "img/icon-calendar-title.svg";